import api from './api';

export const geospatialService = {
  // Get statistical summary of geospatial data
  // GET /api/geospatial/statistics
  getStatistics: async (params = {}) => {
    const response = await api.get('/geospatial/statistics', { 
      params: {
        status: params.status || '',
        damage_type: params.damage_type || '',
        start_date: params.start_date || '',
        end_date: params.end_date || '',
      }
    });
    return response.data;
  },

  // Get heatmap data points
  // GET /api/geospatial/heatmap/data
  getHeatmapData: async (params = {}) => {
    const response = await api.get('/geospatial/heatmap/data', { 
      params: {
        status: params.status || '',
        damage_type: params.damage_type || '',
        start_date: params.start_date || '',
        end_date: params.end_date || '',
      }
    });
    return response.data;
  },

  //GET heatmap data points for public view
  // GET /api/geospatial/public/heatmap/data
  getPublicHeatmapData: async (params = {}) => {
    const response = await api.get('/geospatial/public/heatmap/data', { 
      params: {
        status: params.status || '',
        damage_type: params.damage_type || '',
        start_date: params.start_date || '',
        end_date: params.end_date || '',
      }
    });
    return response.data;
  },

  // Get clustered location data
  // GET /api/geospatial/cluster/data
  getClusterData: async (params = {}) => {
    const response = await api.get('/geospatial/cluster/data', { 
      params: {
        status: params.status || '',
        damage_type: params.damage_type || '',
        start_date: params.start_date || '',
        end_date: params.end_date || '',
      }
    });
    return response.data;
  },

  //GET public clustered location data
  // GET /api/geospatial/public/cluster/data
  getPublicClusterData: async (params = {}) => {
    const response = await api.get('/geospatial/public/cluster/data', { 
      params: {
        status: params.status || '',
        damage_type: params.damage_type || '',
        start_date: params.start_date || '',
        end_date: params.end_date || '',
      }
    });
    return response.data;
  },

  // Perform buffer analysis
  // POST /api/geospatial/buffer/analysis
  bufferAnalysis: async (lat, lng, radius = 5000) => {
    const response = await api.post('/geospatial/buffer/analysis', {
      lat,
      lng,
      radius
    });
    return response.data;
  },

  // Calculate distance between two points
  // POST /api/geospatial/distance/calculate
  calculateDistance: async (point1, point2) => {
    const response = await api.post('/geospatial/distance/calculate', {
      point1,
      point2
    });
    return response.data;
  },

  // Get all locations (from existing geospatial_analysis.py)
  // GET /api/geos/location/all
  getAllLocations: async () => {
    const response = await api.get('/geos/location/all');
    return response.data;
  },

  // Get location by report ID (from existing geospatial_analysis.py)
  // GET /api/geos/location/:report_id
  getLocationByReportId: async (reportId) => {
    const response = await api.get(`/geos/location/${reportId}`);
    return response.data;
  },

  // Get locations in bounding box (from existing geospatial_analysis.py)
  // GET /api/geos/location/box
  getLocationsInBox: async (minx, miny, maxx, maxy) => {
    const response = await api.get('/geos/location/box', {
      params: { minx, miny, maxx, maxy }
    });
    return response.data;
  },
};

export default geospatialService;
